/* ============================================================================
   Bruised LA accessibility menu (2026-11-02)

   Opens snippets/bruised-a11y-panel.liquid from the footer button or Ctrl + X
   and keeps the shopper's adjustments on <html>, saved in localStorage under
   bruised:a11y.

   THE STATE LIVES IN ONE PLACE. window.BZA is published by the inline script
   in the snippet, which runs before first paint. It owns the map from a saved
   value to a class name, the reader, the reduced motion rule and the applier.
   This file reads that object back out, so the pre-paint restore and the live
   toggles can never drift apart. Everything here is the part that CSS cannot
   do: the players, the media, the pointer, the DOM marking and the dialog.

   Notes for whoever edits this next:
   - 'still' is a THREE state value. undefined means follow the operating
     system's prefers-reduced-motion, true and false are the shopper
     overriding it either way. Every other adjustment is 0 to its step count.
   - Picking any single tile clears the profile, because the shopper is no
     longer on that profile. Picking a profile sets its tiles and nothing else.
   - The focus trap is ours, not the theme's: the panel has a second view
     (page structure) built after the panel opens, and the theme's trapFocus
     caches its list at call time, so new buttons would fall outside the trap.
   - Every storage call is wrapped: snippets/bruised-storage-guard.liquid swaps
     in an in memory Storage when the browser denies it, and a denied browser
     must still be able to use the panel for the current page.
   ============================================================================ */
(function () {
  'use strict';

  var BZA = window.BZA;
  var root = document.documentElement;
  var panel = document.getElementById('bruised-a11y-panel');
  if (!panel || !BZA) return;

  var wrap = panel.closest('.bza') || document;
  var backdrop = wrap.querySelector('.bza__backdrop');
  var tip = wrap.querySelector('[data-bza-tip]');
  var live = panel.querySelector('[data-bza-live]');
  var views = {
    main: panel.querySelector('[data-bza-view="main"]'),
    structure: panel.querySelector('[data-bza-view="structure"]')
  };
  var structureList = panel.querySelector('[data-bza-structure-list]');
  var profileNow = panel.querySelector('[data-bza-profile-now]');
  var triggers = document.querySelectorAll('[data-bza-open]');
  var shortcutOn = wrap.hasAttribute && wrap.hasAttribute('data-bza-shortcut');
  var lastTrigger = null;

  /* Each profile is a set of adjustments, nothing more. Everything it does not
     name is cleared, so switching profile never leaves a stray setting on. */
  var PROFILES = {
    motor: { cursor: 1, links: 1, focus: 1, text: 1 },
    colorblind: { contrast: 1, satur: 2, links: 1 },
    cognitive: { mask: 1, font: 2, spacing: 2, titles: 1 },
    visual: { text: 2, lineh: 3, cursor: 1, contrast: 1 },
    epileptic: { still: true, satur: 1 },
    adhd: { mask: 1, still: true, hideimg: 0, links: 1 }
  };

  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var state = BZA.read();

  function save() {
    try {
      var v = {};
      for (var k in BZA.MAP) if (state[k]) v[k] = state[k];
      if (state.still === true || state.still === false) v.still = state.still;
      if (state.profile) v.profile = state.profile;
      window.localStorage.setItem(BZA.KEY, JSON.stringify(v));
    } catch (e) {}
  }

  function stillOn() {
    return BZA.still(state);
  }

  /* --- the parts CSS cannot do -------------------------------------------- */

  /* the sliders and any autoplaying video: CSS can stop neither */
  function players(paused) {
    var F = window.theme && window.theme.Flickity;
    if (F && F.data) {
      document.querySelectorAll('.flickity-enabled').forEach(function (el) {
        var f;
        try { f = F.data(el); } catch (e) { return; }
        if (!f) return;
        try { paused ? f.pausePlayer() : f.unpausePlayer(); } catch (e) {}
      });
    }
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      try {
        if (paused) { v.pause(); return; }
        if (state.mute) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } catch (e) {}
    });
  }

  /* Mute sounds. The original muted value is remembered on the element, so a
     hero video that was always silent stays silent when the mode goes off. */
  function media(on) {
    document.querySelectorAll('video, audio').forEach(function (m) {
      try {
        if (on) {
          if (!m.hasAttribute('data-bza-mute0')) m.setAttribute('data-bza-mute0', m.muted ? '1' : '0');
          m.muted = true;
          m.pause();
        } else if (m.hasAttribute('data-bza-mute0')) {
          m.muted = m.getAttribute('data-bza-mute0') === '1';
          m.removeAttribute('data-bza-mute0');
        }
      } catch (e) {}
    });
  }

  /* Hide images. The img elements go by CSS, instantly and before first paint.
     A CSS background cannot be found by a selector, so the elements whose
     computed background really is a url() are marked here. That keeps every
     gradient and photo scrim alive, which a blanket background-image:none
     would have taken out along with the photos. */
  var bgWalked = false;
  function backgrounds(on) {
    if (!on) {
      document.querySelectorAll('[data-bza-bgimg]').forEach(function (el) { el.removeAttribute('data-bza-bgimg'); });
      bgWalked = false;
      return;
    }
    if (bgWalked) return;
    bgWalked = true;
    var all = document.body.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.closest('.bza')) continue;
      var bg;
      try { bg = window.getComputedStyle(el).backgroundImage; } catch (e) { continue; }
      if (bg && bg.indexOf('url(') !== -1) el.setAttribute('data-bza-bgimg', '');
    }
  }

  /* Image captions. An image is not focusable, so while the mode is on every
     image that has real alt text becomes a tab stop: that is what makes the
     caption reachable without a mouse. Both attributes come straight back off
     when the mode goes off. */
  function captions(on) {
    if (!on) {
      document.querySelectorAll('img[data-bza-tip]').forEach(function (img) {
        img.removeAttribute('data-bza-tip');
        if (img.hasAttribute('data-bza-tabbed')) {
          img.removeAttribute('tabindex');
          img.removeAttribute('data-bza-tabbed');
        }
      });
      hideTip();
      return;
    }
    document.querySelectorAll('img[alt]').forEach(function (img) {
      if (img.closest('.bza')) return;
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) return; /* a decorative image has nothing to say */
      img.setAttribute('data-bza-tip', alt);
      if (!img.hasAttribute('tabindex')) {
        img.setAttribute('tabindex', '0');
        img.setAttribute('data-bza-tabbed', '');
      }
    });
  }

  function showTip(img) {
    if (!tip || !state.imgtip) return;
    var text = img.getAttribute('data-bza-tip');
    if (!text) return;
    tip.textContent = text;
    tip.hidden = false;
    var r = img.getBoundingClientRect();
    var box = tip.getBoundingClientRect();
    var top = r.bottom + 8;
    if (top + box.height > window.innerHeight - 8) top = Math.max(8, r.top - box.height - 8);
    var left = Math.min(Math.max(8, r.left), Math.max(8, window.innerWidth - box.width - 8));
    tip.style.top = Math.round(top) + 'px';
    tip.style.left = Math.round(left) + 'px';
  }

  /* guarded: this runs on every scroll event, and writing hidden="" when it is
     already hidden still costs a style invalidation on every frame */
  function hideTip() {
    if (tip && !tip.hidden) tip.hidden = true;
  }

  /* The reading guide and the reading mask both ride one custom property, so
     the pointer is read once and written once per frame. */
  var pointerBound = false;
  var pending = 0;
  function pointer(on) {
    if (!on || pointerBound) return;
    pointerBound = true;
    document.addEventListener('pointermove', function (event) {
      if (!state.guide && !state.mask) return;
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = 0;
        root.style.setProperty('--bza-y', Math.round(event.clientY) + 'px');
      });
    }, { passive: true });
  }

  function apply() {
    BZA.apply(state);
    players(stillOn());
    media(!!state.mute);
    backgrounds(!!state.hideimg);
    captions(!!state.imgtip);
    pointer(!!state.guide || !!state.mask);
  }

  /* --- the panel's own controls ------------------------------------------- */

  function stepWord(btn, value) {
    var steps = parseInt(btn.getAttribute('data-bza-steps'), 10) || 1;
    if (!value) return 'off';
    var names = btn.getAttribute('data-bza-step-names');
    if (names) {
      var list = names.split(',');
      if (list[value - 1]) return list[value - 1].trim();
    }
    if (steps === 1) return 'on';
    return 'step ' + value + ' of ' + steps;
  }

  function syncUI() {
    panel.querySelectorAll('[data-bza-set]').forEach(function (btn) {
      var key = btn.getAttribute('data-bza-set');
      var value = key === 'still' ? (stillOn() ? 1 : 0) : (state[key] || 0);
      var steps = parseInt(btn.getAttribute('data-bza-steps'), 10) || 1;
      btn.setAttribute('aria-pressed', value > 0 ? 'true' : 'false');

      /* the step is part of the button's own name, not a colour */
      var sr = btn.querySelector('[data-bza-sr]');
      if (sr) sr.textContent = steps > 1 ? ', ' + stepWord(btn, value) : '';

      var bars = btn.querySelectorAll('.bza__bar');
      for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('is-on', i < value);
    });

    panel.querySelectorAll('[data-bza-switch]').forEach(function (btn) {
      var key = btn.getAttribute('data-bza-switch');
      btn.setAttribute('aria-checked', state[key] ? 'true' : 'false');
    });

    var activeName = 'None';
    panel.querySelectorAll('[data-bza-profile]').forEach(function (btn) {
      var id = btn.getAttribute('data-bza-profile');
      var on = id ? state.profile === id : !state.profile;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && id) {
        var name = btn.querySelector('.bza__profile__name');
        activeName = name ? name.textContent : id;
      }
    });
    if (profileNow) profileNow.textContent = activeName;
  }

  function say(message) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  }

  function commit(message) {
    apply();
    save();
    syncUI();
    if (message) say(message);
  }

  function setProfile(id) {
    var blank = BZA.blank();
    for (var k in BZA.MAP) state[k] = blank[k];
    state.still = undefined;
    state.profile = id || null;
    var preset = id ? PROFILES[id] : null;
    if (preset) for (var p in preset) state[p] = preset[p];
    return preset;
  }

  /* --- page structure ----------------------------------------------------- */

  var LANDMARKS = 'main, header, footer, aside, [role="main"], [role="navigation"], [role="banner"], [role="contentinfo"], [role="search"], [role="region"][aria-label], nav';
  /* short badges, so a landmark never reads as a chopped off word, and a plain
     name for each: a landmark is named by its job, never by the text inside it */
  var MARK_NAMES = {
    main: 'Main', nav: 'Nav', navigation: 'Nav', header: 'Head', banner: 'Head',
    footer: 'Foot', contentinfo: 'Foot', aside: 'Side', search: 'Find', region: 'Area'
  };
  var MARK_LABELS = {
    main: 'Main content', nav: 'Navigation', navigation: 'Navigation',
    header: 'Header', banner: 'Header', footer: 'Footer', contentinfo: 'Footer',
    aside: 'Side panel', search: 'Search', region: 'Section'
  };
  var LINK_CAP = 40;

  function seen(el) {
    if (el.closest('.bza')) return false;
    if (el.closest('[aria-hidden="true"]')) return false;
    if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
    /* a closed off canvas panel (the cart drawer, the menu drawer) still has a
       real size, so its headings would otherwise be offered as somewhere to
       jump to. Anything parked past either edge of the page is not on it. */
    var r = el.getBoundingClientRect();
    var w = document.documentElement.clientWidth;
    if (r.right <= 0 || r.left >= w) return false;
    return true;
  }

  /* el.textContent on a landmark swallows every inline <style> and <script>
     inside it, which is how a footer ended up named ".site-footer-wrapper {
     --PT: 72px; ... }". This walks text nodes and skips those branches. */
  function textOf(el) {
    var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        while (p && p !== el) {
          var tag = p.nodeName;
          if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'NOSCRIPT' || tag === 'TEMPLATE') return NodeFilter.FILTER_REJECT;
          p = p.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var out = '';
    var n;
    while ((n = walk.nextNode()) && out.length < 160) out += ' ' + n.nodeValue;
    return out;
  }

  function trim(text) {
    text = (text || '').replace(/\s+/g, ' ').trim();
    return text.length > 90 ? text.slice(0, 89).trim() + '…' : text;
  }

  function label(el) {
    return trim(el.getAttribute('aria-label') || textOf(el) || el.getAttribute('title'));
  }

  function group(heading, rows) {
    if (!rows.length) return null;
    var frag = document.createDocumentFragment();
    var h = document.createElement('h4');
    h.className = 'bza__struct__head';
    h.textContent = heading;
    frag.appendChild(h);
    rows.forEach(function (row) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bza__jump';
      var kind = document.createElement('span');
      kind.className = 'bza__jump__kind';
      kind.textContent = row.kind;
      var text = document.createElement('span');
      text.className = 'bza__jump__text';
      text.textContent = row.text;
      b.appendChild(kind);
      b.appendChild(text);
      b.addEventListener('click', function () { jump(row.el); });
      frag.appendChild(b);
    });
    return frag;
  }

  function buildStructure() {
    if (!structureList) return;
    structureList.textContent = '';

    var headings = [];
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (el) {
      if (!seen(el)) return;
      var text = label(el);
      if (!text) return;
      headings.push({ kind: el.tagName, text: text, el: el });
    });

    var marks = [];
    document.querySelectorAll(LANDMARKS).forEach(function (el) {
      if (!seen(el)) return;
      if (marks.some(function (m) { return m.el === el; })) return;
      var role = el.getAttribute('role') || el.tagName.toLowerCase();
      var name = trim(el.getAttribute('aria-label')) || MARK_LABELS[role] || role;
      var same = marks.filter(function (m) { return m.text.indexOf(name) === 0; }).length;
      marks.push({ kind: MARK_NAMES[role] || role, text: same ? name + ' ' + (same + 1) : name, el: el });
    });

    var links = [];
    var urls = {};
    document.querySelectorAll('a[href]').forEach(function (el) {
      if (links.length >= LINK_CAP || !seen(el)) return;
      var text = label(el);
      if (!text) return;
      var key = el.getAttribute('href') + '|' + text;
      if (urls[key]) return;
      urls[key] = 1;
      links.push({ kind: 'Link', text: text, el: el });
    });

    var all = document.querySelectorAll('a[href]').length;
    [group('Headings', headings), group('Landmarks', marks), group('Links', links)].forEach(function (frag) {
      if (frag) structureList.appendChild(frag);
    });

    if (!headings.length && !marks.length && !links.length) {
      var empty = document.createElement('p');
      empty.className = 'bza__struct__more';
      empty.textContent = 'Nothing on this page to jump to.';
      structureList.appendChild(empty);
    } else if (all > LINK_CAP) {
      var more = document.createElement('p');
      more.className = 'bza__struct__more';
      more.textContent = 'The first ' + LINK_CAP + ' of ' + all + ' links on this page.';
      structureList.appendChild(more);
    }
  }

  function jump(el) {
    close();
    el.setAttribute('data-bza-jump', '');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try {
      el.scrollIntoView({ block: 'start', behavior: stillOn() ? 'auto' : 'smooth' });
    } catch (e) {
      el.scrollIntoView();
    }
    el.focus({ preventScroll: true });
  }

  function view(name) {
    for (var k in views) if (views[k]) views[k].hidden = k !== name;
    if (name === 'structure') buildStructure();
  }

  /* --- open and close ----------------------------------------------------- */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function open(fromTrigger) {
    lastTrigger = fromTrigger || document.activeElement || triggers[0] || null;
    if (backdrop) backdrop.hidden = false;
    panel.hidden = false;
    root.classList.add('bza-open');
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: views.main }));

    window.requestAnimationFrame(function () {
      if (backdrop) backdrop.classList.add('is-open');
      panel.classList.add('is-open');
    });

    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    view('main');
    panel.focus();
    document.addEventListener('keydown', onPanelKeydown, true);
    document.addEventListener('focusin', onFocusIn);
  }

  function close() {
    if (panel.hidden) return;
    document.removeEventListener('keydown', onPanelKeydown, true);
    document.removeEventListener('focusin', onFocusIn);
    panel.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    root.classList.remove('bza-open');
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: 0 }));

    var done = function () {
      panel.hidden = true;
      if (backdrop) backdrop.hidden = true;
    };
    if (stillOn() || (reduceQuery && reduceQuery.matches)) done();
    else window.setTimeout(done, 240);

    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }

  function isOpen() {
    return !panel.hidden;
  }

  /* Our own trap: the list is recomputed on every Tab, so the buttons the
     page structure view builds after opening are inside it too. */
  function onPanelKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) { event.preventDefault(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    var now = document.activeElement;
    if (event.shiftKey && (now === first || now === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && now === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onFocusIn(event) {
    if (!isOpen()) return;
    if (panel.contains(event.target)) return;
    panel.focus();
  }

  function isEditable(el) {
    if (!el) return false;
    if (el.isContentEditable) return true;
    var tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
  }

  /* --- wiring ------------------------------------------------------------- */

  triggers.forEach(function (t) {
    t.addEventListener('click', function () {
      isOpen() ? close() : open(t);
    });
  });

  wrap.querySelectorAll('[data-bza-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  panel.addEventListener('click', function (event) {
    var tile = event.target.closest('[data-bza-set]');
    if (tile) {
      var key = tile.getAttribute('data-bza-set');
      var steps = parseInt(tile.getAttribute('data-bza-steps'), 10) || 1;
      if (key === 'still') state.still = !stillOn();
      else state[key] = ((state[key] || 0) + 1) % (steps + 1);
      /* one tile picked by hand means the shopper is off the profile */
      state.profile = null;
      var now = key === 'still' ? (stillOn() ? 1 : 0) : state[key];
      var name = tile.querySelector('.bza__tile__label');
      commit((name ? name.textContent : key) + ': ' + stepWord(tile, now) + '.');
      return;
    }

    var sw = event.target.closest('[data-bza-switch]');
    if (sw) {
      var skey = sw.getAttribute('data-bza-switch');
      state[skey] = state[skey] ? 0 : 1;
      var sname = sw.querySelector('.bza__switch__name');
      commit((sname ? sname.textContent : skey) + ': ' + (state[skey] ? 'on' : 'off') + '.');
      return;
    }

    var prof = event.target.closest('[data-bza-profile]');
    if (prof) {
      var id = prof.getAttribute('data-bza-profile');
      var pname = prof.querySelector('.bza__profile__name');
      setProfile(id);
      commit(id
        ? (pname ? pname.textContent : id) + ' profile on.'
        : 'Profile cleared. Everything is back to normal.');
      return;
    }

    var disc = event.target.closest('[data-bza-disc]');
    if (disc) {
      var openNow = disc.getAttribute('aria-expanded') === 'true';
      disc.setAttribute('aria-expanded', openNow ? 'false' : 'true');
      var region = document.getElementById(disc.getAttribute('aria-controls'));
      if (region) region.hidden = openNow;
      return;
    }

    if (event.target.closest('[data-bza-structure]')) { view('structure'); panel.focus(); return; }
    if (event.target.closest('[data-bza-back]')) { view('main'); panel.focus(); return; }

    if (event.target.closest('[data-bza-reset]')) {
      setProfile(null);
      commit('Reset. Everything is back to normal.');
    }
  });

  /* Ctrl + X. Ignored while the shopper is typing, and a real cut is never
     swallowed: with a selection on the page the browser keeps the keystroke. */
  if (shortcutOn) {
    document.addEventListener('keydown', function (event) {
      if (!event.ctrlKey || event.metaKey || event.altKey) return;
      if (event.key !== 'x' && event.key !== 'X') return;
      if (isEditable(document.activeElement)) return;
      var selection = window.getSelection ? String(window.getSelection()) : '';
      if (selection) return;
      event.preventDefault();
      isOpen() ? close() : open(null);
    });
  }

  /* the caption follows the pointer and the keyboard, one listener each */
  document.addEventListener('pointerover', function (event) {
    if (!state.imgtip) return;
    var img = event.target.closest ? event.target.closest('img[data-bza-tip]') : null;
    if (img) showTip(img);
    else if (!event.target.closest('.bza__tip')) hideTip();
  });
  document.addEventListener('focusin', function (event) {
    if (!state.imgtip) return;
    var img = event.target.closest ? event.target.closest('img[data-bza-tip]') : null;
    if (img) showTip(img);
    else hideTip();
  });
  window.addEventListener('scroll', hideTip, { passive: true });

  /* nothing starts playing while Mute sounds is on */
  document.addEventListener('play', function (event) {
    if (!state.mute) return;
    try { event.target.muted = true; event.target.pause(); } catch (e) {}
  }, true);

  /* the OS setting still counts while the shopper has not picked a side */
  if (reduceQuery && reduceQuery.addEventListener) {
    reduceQuery.addEventListener('change', function () {
      if (state.still === true || state.still === false) return;
      apply();
      syncUI();
    });
  }

  /* a slider or a photo built after this file ran (the drawer, a quick view)
     has to be told as well, or the mode comes back off with it */
  ['theme:cart:change', 'theme:cart:update', 'theme:quickview:open'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (stillOn()) players(true);
      if (state.mute) media(true);
      if (state.imgtip) captions(true);
    });
  });

  apply();
  syncUI();
})();
